export function normalizeWalletChainId(chainId) {
  if (!chainId) {
    return chainId
  }

  if (chainId.startsWith('0x')) {
    return chainId
  }

  const parsed = parseInt(chainId, 10)
  if (Number.isNaN(parsed)) {
    throw new Error(`Invalid chain id: ${chainId}`)
  }

  return `0x${parsed.toString(16)}`
}

export function parseRpcUrls(value) {
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : [parsed]
  } catch (error) {
    if (/^https?:\/\//.test(value)) {
      return [value]
    }

    throw new Error(`Invalid VUE_APP_RPC_URLS value: ${error.message}`)
  }
}

export function buildAddEthereumChainParams({
  chainId,
  rpcUrls,
  chainName,
  currencyName,
  currencySymbol
}) {
  return [
    {
      chainId,
      chainName,
      rpcUrls: parseRpcUrls(rpcUrls),
      nativeCurrency: {
        name: currencyName,
        symbol: currencySymbol,
        decimals: 18
      }
    }
  ]
}
